{
  "column": {
    "name": "Nome",
    "type": "Tipo",
    "subscribedServices": "Servizi sottoscritti",
    "expirationDate": "Data di scadenza",
    "expirationDateFormat": "DD/MM/YYYY alle HH:mm"
  },
  "addSingleCertificate": "Aggiunta di un certificato",
  "addCertificate": "Aggiungere un certificato",
  "updateCertificate": "Aggiornare il certificato",
  "certificate": {
    "typeTitle": "Tipo di certificato",
    "deviceTrustchain": "Device Trustchain",
    "pkiRootCa": "MS PKI root CA",
    "ldapsRootCa": "LDAPS root CA"
  },
  "caRestrictionInformation": "Il certificato caricato deve essere un file .PEM e deve pesare meno di 1 MB.",
  "dropCertificate": "Caricare qui il certificato o fare clic qui per avviare la selezione",
  "noCertificate": "Nessun certificato è iscritto nel quadro del truststore",
  "validation": {
    "rootCa": "Il certificato è obbligatorio e deve essere nel formato .PEM",
    "certType": "Il tipo di certificato è obbligatorio"
  }
}
